import { gsap } from 'gsap'

import Common from 'js/_core/Common'
import { roundEx } from 'js/utils/Maths'

import ViewController from 'js/app/controllers/ViewController'
import LottieAnimation from 'js/modules/_base/effects/lottie/LottieAnimation'
import HomeFadeSlideshow from 'js/modules/projects/ui/HomeFadeSlideshow'
import { getTargetOffsetTop } from 'js/utils/Utils'

export default class CareerSingleViewController extends ViewController {
  constructor(content) {
    super(content)
    if (this.debug) {
      this.pageName = '[CareerSingle]'
    }

    // ページ別のコンテンツ(html)はここからアクセスできます
    this.$content = content
  }

  async willLoad() {
    await super.willLoad()
  }

  async didLoad() {
    await super.didLoad()
  }

  async beforeEnter() {
    await super.beforeEnter()
  }

  async enter() {
    this.addHandlers()
    await super.enter()
    this._addObservers()
    this._setLayout()
  }

  async afterEnter() {
    await super.afterEnter()
  }

  async beforeLeave() {
    await super.beforeLeave()
    this._removeObservers()
    this.removeHandlers()
  }

  async leave() {
    await super.leave()
  }

  async afterLeave() {
    await super.afterLeave()
  }

  _set$() {
    super._set$()
    this.$firstInner = this.$content.querySelector('[data-layout="single-page_first_inner"]')
    this.$firstSideWraps = this.$content.querySelectorAll('[data-lyaout="single-page_first_side_wrap"]')
    this.$firstSides = this.$content.querySelectorAll('[data-lyaout="single-page_first_side"]')
  }

  addHandlers() {
    super.addHandlers()
    if (Common.resize) {
      Common.resize.addHandler(() => {
        this.onResize()
      }, 'CareerSingleViewControllerResize')
    }
  }

  removeHandlers() {
    super.removeHandlers()
    if (Common.resize) {
      Common.resize.removeHandler('CareerSingleViewControllerResize')
    }
  }

  _addObservers() {}

  _removeObservers() {}

  _setLayout() {
    if (!Common.detection.isMobileLayout) {
      if (this.$firstInner) {
        let firstInnerTop = getTargetOffsetTop(this.$firstInner)
        firstInnerTop = roundEx(firstInnerTop, 1000)

        if (this.$firstSides && this.$firstSides.length) {
          this.$firstSides.forEach(($firstSide) => {
            $firstSide.style.marginTop = `${-1 * firstInnerTop}px`
          })
        }

        if (this.$firstSideWraps && this.$firstSideWraps.length) {
          this.$firstSideWraps.forEach(($firstSideWrap) => {
            $firstSideWrap.style.height = `calc( 100% + ${firstInnerTop}px )`
          })
        }
      }
    }
  }

  onResize() {
    super.onResize()
    this._setLayout()
  }
}